module.exports = __webpack_public_path__ + "img/bg_avatar_female_79.50d45f2e.png";